import { requester } from '../utils';

export const fetchAllMenuItems = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-menu-item?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const changeMenuItemActivity = (id, isActive) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-menu-item/active`,
        method: 'PUT',
        data: {
          id,
          isActive
        },
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchMenuItemById = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-menu-item/${id}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const deleteMenuItem = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-menu-item/${id}`,
        method: 'DELETE',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchAllDeletedMenuItems = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-menu-item/deleted?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const insertNewMenuItem = ({
  title,
  displayOrder,
  menuCategoryId,
  isActive,
  price,
  description,
  meals,
  imageFileName
}) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-menu-item`,
        method: 'POST',
        data: {
          title,
          displayOrder,
          menuCategoryId,
          isActive,
          price,
          description,
          meals,
          imageFileName
        },
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const updateMenuItem = itemObject => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-menu-item`,
        method: 'PUT',
        data: itemObject,
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getMenuItemsImages = () => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-menu-item/menuItem-images`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject('get menu item images error', err);
      });
  });
};
